import './GenerateProject.css'
import NewProjectFromIntakeForm from '../NewProjectFromIntakeForm/NewProjectFromIntakeForm';

export default function GenerateProject({form, existingProjectNumbers, users, toggleNotifications}) {
  return (
    <div className='GenerateProject modal fade' id='newProjectFromIntakeFormModal' data-bs-keyboard="false" aria-labelledby={`newProjectFromIntakeFormModalHeader`}>
      <NewProjectFromIntakeForm form={form} existingProjectNumbers={existingProjectNumbers} users={users} toggleNotifications={toggleNotifications} />
    </div>
  )
}
